export default __webpack_public_path__ + "static/black-black-cork-16bfba9cce17b9bf260cd710855a0388.png";